import classNames from "classnames";

type MobileNavLinkProps = {
  label: string;
  onClick: () => void;
  variant?: "list" | "chip";
};

export function MobileNavLink({
  label,
  onClick,
  variant = "list",
}: MobileNavLinkProps) {
  // 导航链接（列表项 / 卡片按钮）
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "w-full text-left transition-colors",
        variant === "list" &&
          "min-h-[44px] py-3 text-[20px] text-yoyo-text active:text-yoyo-primary",
        variant === "chip" &&
          "min-h-[44px] rounded-xl border border-yoyo-border/70 bg-yoyo-muted/40 px-3 py-3.5 text-[20px] text-yoyo-text active:border-yoyo-primary/30 active:bg-yoyo-primary/5",
      )}
    >
      {label}
    </button>
  );
}
